import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'createMapIcon'
})
export class CreateMapIconPipe implements PipeTransform {

  transform(train: MonitoredTrain, showTrainState?: boolean, markOfflineTrain?: boolean): unknown {

    const color = (showTrainState || (markOfflineTrain && (train.alarmState.status === "OFFLINE"))) ? train.alarmState && train.alarmState.background && train.alarmState.background.toLowerCase() : 'lime';
    const textColor = train && train.alarmState && train.alarmState.textColor || 'black';
    const trainId = train.name;
    
    let canvas, context;
    let width, height;
    let offset;
    canvas = document.createElement("canvas");
    context = canvas.getContext("2d");
    
    switch (train.mapIconForm) {

      case 'rectangular':
          const textWidth = context.measureText(trainId);
          width = textWidth.width * 1.5;
          height = 25;
          canvas.width = width + 1;
          canvas.height = height + 15;
          canvas.style.width =`${width}px`;
          canvas.style.height = `${height + 20}px`;
          
          context.clearRect(0,0,width,height);
          context.lineWidth = 0;
          context.fillStyle = color;
          context.strokeStyle = "#000";
          this.drawRect(context, 0, 0, width, height);
          context.fill();
          context.stroke();
          context.fillStyle = textColor;
          context.strokeStyle = color;
          context.font = "12px Arial";
          context.textBaseline  = "top";
          // centre the text.
          context.fillText(trainId,
            Math.floor((width / 2) - (textWidth.width / 1.75)),
            8
          );
          const triangleWidth = 5;
          const triangleHeight = 10;
          const triangleY = canvas.height - triangleWidth ;
          this.drawTriangle(context, canvas.width / 2, triangleY, triangleWidth, triangleHeight, "#000");
          
          return {
            url: canvas.toDataURL(),

          }
        break;
      default:
          context.font = "25px Arial";
          width = 32;
          height = 42;
          offset = 14;
          const dim = 84;
          canvas.width = dim;
          canvas.height = dim + 20;
          canvas.style.width = "32px";
          canvas.style.height = "42px";
          const centerX = dim / 2;
          const centerY = dim / 2;
          const radius = dim / 2 - 2;
          const startAngle = 0.65 * Math.PI;
          const endAngle = 0.35 * Math.PI;
          context.arc(centerX, centerY, radius, startAngle, endAngle, false);
          context.fillStyle = 'white';
          context.fill();
          context.lineWidth = 1;
          context.strokeStyle = '#000';
          context.closePath();
          context.stroke();
          context.beginPath();
          context.arc(centerX, centerY, radius - 8, 0, 2 * Math.PI, false);
          context.fillStyle = color;
          context.fill();
          context.closePath();
          context.beginPath();
          context.beginPath();
          context.textAlign = 'center';
          context.textBaseline = 'middle';
          context.font = "25px Arial";
          context.fillStyle = textColor;
          context.fillText(trainId, centerX, centerY);
          context.restore();
          context.save();
          context.beginPath();
          context.moveTo(centerX - offset, radius * 2);
          context.lineTo(centerX, radius * 2 + 18);
          context.lineTo(centerX + offset, radius * 2);
          context.fillStyle = 'black';
          context.fill();
          context.lineWidth = 1;
          context.strokeStyle = 'black';
          context.closePath();
          context.stroke();
          context.restore();
          return {
            url: canvas.toDataURL(),
            scaledSize: {
              width,
              height
            }
          }

    }
    
    
  }

  drawRect = (context, x, y, width, height) => {
    const radius = 0;
    context.beginPath();
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width -
    radius, y + height);
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
    context.closePath();
  }

  drawTriangle = (context, x, y, triangleWidth, triangleHeight, fillStyle) => {
    context.beginPath();
    context.moveTo(x, y);
    context.lineTo(x + triangleWidth, y - triangleHeight);
    context.lineTo(x - triangleWidth, y - triangleHeight);
    context.closePath();
    context.fillStyle = fillStyle;
    context.fill();
    }

}
